export const AUTH_CLEARED_EVENT = "mpower-auth-cleared";
export const AUTH_LOGOUT_KEY = "mpower-auth-logout";
export const OAUTH_INTENT_KEY = "oauth_login_intent";
const TOKEN_KEYS = ["access_token", "refresh_token", "session_token", "client_token"];
let revision = 0;

export const authRevision = () => revision;
export const isLoginEntry = (pathname = window.location.pathname) => ["/login", "/join"].includes(pathname.replace(/\/$/, ""));
export const requiresFreshLogin = () => localStorage.getItem("mpower-requires-login") === "1";

export function storedAuthTokens() {
  const cookies = Object.fromEntries(document.cookie.split(";").map((entry) => {
    const split = entry.trim().indexOf("=");
    return split < 0 ? [entry.trim(), ""] : [entry.trim().slice(0, split), entry.trim().slice(split + 1)];
  }));
  return [...new Set(TOKEN_KEYS.flatMap((key) => [localStorage.getItem(key), sessionStorage.getItem(key), cookies[key]]).filter(Boolean))].slice(0, 12);
}

export function clearBrowserAuth(broadcast = true) {
  revision += 1;
  for (const key of [...TOKEN_KEYS, "client_id", OAUTH_INTENT_KEY]) {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }
  // HttpOnly cookies are expired by the backend; also remove any legacy JS-readable copies.
  for (const name of [...TOKEN_KEYS, OAUTH_INTENT_KEY]) {
    document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=None; Secure`;
  }
  localStorage.setItem("mpower-requires-login", "1");
  if (broadcast) localStorage.setItem(AUTH_LOGOUT_KEY, `${Date.now()}-${Math.random()}`);
  window.dispatchEvent(new Event(AUTH_CLEARED_EVENT));
}

export function acceptFreshAuth(data, clientSession = false) {
  if (data.access_token) localStorage.setItem(clientSession ? "client_token" : "access_token", data.access_token);
  if (clientSession) localStorage.setItem("client_id", data.id);
  localStorage.removeItem("mpower-requires-login");
}